/**
 *
 * @file 公共接口
 *
 **/

import AXIOS from '@/utils/$axios';
// 查询图片原始文件地址
export const commentAdjunctView = data =>
    AXIOS.post('/space/project/project-drawing/comment-adjunct-view', data);

//获取组织架构和项目业务角色

export const getRoleList = data =>
    AXIOS.post('/space/enterprise/common/role-list', data);

export const commonUpload = data => {
    const headers = {
        'Content-Type': 'multipart/form-data;charset=UTF-8',
    };
    return AXIOS.post('/space/enterprise/common/upload', data, { headers });
};
